import type { FunctionComponent } from "react"

import { clsx } from "clsx"
import { useParams } from "next/navigation"

import { BreadcrumbTrail } from "@jobteaser/ui-kit/components/BreadcrumbTrail"

import { Edition } from "@/modules/eventDetails/client/components/Edition/Edition"
import { useEventDetailsData } from "@/modules/eventDetails/client/hooks/useEventDetailsData"
import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useLocale } from "@/modules/locales/useLocale"

import { StructuredData } from "./StructuredData"

import styles from "./Breadcrumb.module.css"
import layoutStyles from "@/modules/eventDetails/client/components/Layout/Layout.module.css"

export type BreadcrumbItem = {
  title: string
  href?: string
}

const EVENTS_BASENAME = "events"

export const Breadcrumb: FunctionComponent = () => {
  const { t } = useTranslation(["shared_header"])
  const locale = useLocale()
  const { eventSlug } = useParams<{ eventSlug: string }>()
  const event = useEventDetailsData(eventSlug)

  if (!event) return null

  const { title } = event

  const breadcrumbs: BreadcrumbItem[] = [
    { href: `/${locale}`, title: t("shared_header.home") },
    { href: `/${locale}/${EVENTS_BASENAME}`, title: t("shared_header.nav_events") },
    { title },
  ]

  return (
    <div className={clsx(styles.main, layoutStyles.top)}>
      <StructuredData data={breadcrumbs} />
      <BreadcrumbTrail breadcrumbs={breadcrumbs} />
      <Edition />
    </div>
  )
}
